import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FirstScreen.module.css';
import PrivacyPolicy from '../components/privacy/Privacy';
import ContactForm from '../ReceptionistComponents/form/form';
import logoHamisrad from '../recImages/logoHamisrad.png';


const FirstScreenRec = () => {
  const [agreed, setAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const nameRef = useRef(null);
  const phoneRef = useRef(null);

  const reciver = "Kerenaxelrod@gmail.com";
  const serverUrl =
    "https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead";
  const webhookUrl =
    "https://hook.us1.make.com/btghlzqtwm5c0hw1xali1h2h973ii1pd";

  const sendToWebhook = async (data) => {
    try {
      const response = await fetch(webhookUrl, {
        method: "POST",
        body: new URLSearchParams(data),
      });
      console.log("Webhook sent successfully", response.status);
    } catch (err) {
      console.error("Webhook error:", err);
    }
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!agreed) {
      alert("עליך לאשר את תנאי השימוש ומדיניות הפרטיות");
      return;
    }

    const name = nameRef.current.value;
    const phone = phoneRef.current.value;

    if (!name || !phone) {
      alert("אנא מלא את כל השדות");
      return;
    }

    setIsSubmitting(true);

    const serverData = {
      name,
      phone,
      email: "",
      reason: "קורס-אדמיניסטרציה",
      reciver,
    };

    const webhookData = {
      name,
      phone,
      email: "",
      source: "hamisrad.co.il/קורס-אדמיניסטרציה",
      timestamp: new Date().toISOString(),
    };

    sendToWebhook(webhookData);

    try {
      const serverResponse = await fetch(serverUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(serverData),
      });

      if (!serverResponse.ok) {
        throw new Error("submit failed");
      }

      setIsSubmitting(false);

      // מעבר לדף תודה
      navigate('/תודה');

    } catch (err) {
      console.error(err);
      alert("התרחשה שגיאה, נסה שוב מאוחר יותר");
      setIsSubmitting(false);
    }
  };

  // Vimeo video ID
  const vimeoVideoId = "1158101133";

  // Load Vimeo Player API script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup: remove script when component unmounts
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className={styles.heroContainer} dir="rtl">
      <div className={styles.contentWrapper}>
        <div className={styles.contentSection}>
      
          <div className={styles.textContent}>
            <div className={styles.logoContainer}>
              <img src={logoHamisrad} alt="המשרד לוגו" className={styles.logo} />
            </div>
            <h1 className={styles.title}>
              השינוי בקריירה שלך מתחיל כאן
              <br />
              <span className={styles.titleHighlight}>תעצרי ותקשיבי לסרטון הבא</span>
            </h1>
          </div>

          <div className={styles.videoContainer}>
            <div className={styles.videoPlayer}>
              <div className={styles.vimeoWrapper}>
                <iframe
                  className={styles.vimeoPlayer}
                  src={`https://player.vimeo.com/video/${vimeoVideoId}?autoplay=1&muted=0&badge=0&autopause=0&player_id=0&app_id=58479`}
                  title="IMG_5992"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default FirstScreenRec;


